export const defaultState = () => ({
  discountId: null,
  errors: {},
  formData: {
    name: '',
    validFrom: '',
    validTo: '',
    createdAt: '',
    isCountdownEnabled: false,
    countries: [],
    services: [],
  },
});

export default () => ({
  isShown: false,
  discountLoading: false,
  time: '',
  ...defaultState(),
});
